import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { TravelReservation } from '@com-delta-idp/mnx-trip-management-shared-ui';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  SEARCH_TRIPS_URL,
  Trips_Request,
  UPCOMING_TRIPS_URL
} from '../models/constants/search-config.constant';
import { CreditRequest } from '../models/interface/request.interface';
import { CreditCardSearchService } from '../services/credit-card-search.service';
import { FeatureFlagFacade } from './feature-flag.facade';
@Injectable({
  providedIn: 'root'
})
export class CreditCardFacade {
  constructor(
    public search: CreditCardSearchService,
    public flag: FeatureFlagFacade,
    public session: UserSessionService
  ) {}

  setSession(
    result: TravelReservation | HttpErrorResponse,
    fName: string,
    lName: string
  ): void {
    this.isSuccess(result)
      ? this.setSuccess(result, fName, lName)
      : this.setFailure(result);
  }

  isSuccess(
    result: TravelReservation | HttpErrorResponse
  ): result is TravelReservation {
    return 'travelReservations' in result;
  }

  getList(request: CreditRequest): void {
    this.search
      .getPNRList(request)
      .pipe(
        map((response) => response),
        catchError((error) => of(error as HttpErrorResponse))
      )
      .subscribe((trips) => {
        this.setSession(trips, request.fName, request.lName);
      });
  }

  setFailure = (result: HttpErrorResponse): void => {
    this.session.getUserSession().subscribe((data) => {
      if (Object.keys(data).length > 0 && data.loggedIn) {
        sessionStorage.setItem(
          Trips_Request,
          JSON.stringify({
            error: true
          })
        );
        window.location.href = UPCOMING_TRIPS_URL;
      } else {
        window.location.href =
          SEARCH_TRIPS_URL +
          (result?.error?.errors ? result.error.errors[0].code : '');
      }
    });
  };

  setSuccess = (
    result: TravelReservation,
    fName: string,
    lName: string
  ): void => {
    const pnrList = result?.travelReservations?.map(
      (list) => list.reservation.bookingReferences[0].id
    );
    sessionStorage.setItem(
      Trips_Request,
      JSON.stringify({
        list: pnrList,
        fName: fName,
        lName: lName,
        error: false
      })
    );
    window.location.href = UPCOMING_TRIPS_URL;
  };

  canProceed = (): Observable<boolean> =>
    this.flag.getFlag().pipe(
      map((response) => response.flags.creditCardSearch),
      catchError(() => of(false))
    );

  getPaymentFlag = (): Observable<boolean> =>
    this.flag.getFlag().pipe(
      map((response) => response.flags.paymentReference),
      catchError(() => of(false))
    );
}
